import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Button,
  useMediaQuery,
  Grid,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import {
  blackColor,
  blackShade05,
  blackShade159,
  blackShade19,
  blueColor04,
  border25,
  greenStatusColor,
  mobilePrimary,
  orangeStatusColor,
  perpleColor1,
  redStatusColor,
  whiteColor,
} from "../../configs/styles/muiThemes";
import SelectWithLabel from "../../components/Input/SelectWithLabel";
import ReportSearch from "../../components/Input/ReportSearch";
import { white } from "material-ui/styles/colors";
import SelectTimeWithLabel from "../../components/Input/SelectTimeWithLabel";
import DateSearchFilterWithlabel from "./PopupCard/DateSearchFilterWithlabel";
import { searchOrdersReportsByFiltersApi } from "../../service/api_calls/ordersReports/OrderReportsAPi";
import {
  dynamicSort,
  getOrderDeliveryTypeTextReverse,
  getOrderStatusTextreverse,
  getOrderTypeTextreverse,
} from "../../utils/helper";
import { clearorderReportsInfo } from "../../reducers/orderReports/orderReportsSlice";
import { useDispatch } from "react-redux";
import moment from "moment";

function OrderReportFilterCard({
  title,
  categoryList,
  subCategoryList,
  selectedCategory,
  selectedSubCategory,
  handleCategoryChange,
  handleSubCategoryChange,
  onApply,
  onCancel,
  loader,
  onAllClear,
  error,
  filterlabel,
  filtersublabel,
  setorderData,
  setSearchValues,
  searchValues,
  filterCount,
  setfilterCount,
  bapNameList,
  searchOndcBapNameBySubscriberId,
}) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const dispatch = useDispatch();

  const [isError, setisError] = useState(null);

  // const getSearchCriteria = (searchValues) => {
  //   const {
  //     orderId,
  //     ondcOrderId,
  //     orderType,
  //     buyerApp,
  //     status,
  //     deliveryType,
  //     orderDateRange, // { from: Date, to: Date }
  //     deliveredDateRange, // { from: Date, to: Date }
  //   } = searchValues;

  //   if (orderId) return { field: "Order ID", value: orderId };
  //   if (ondcOrderId) return { field: "ONDC Order ID", value: ondcOrderId };
  //   if (orderType) return { field: "Order Type", value: orderType };
  //   if (buyerApp) return { field: "Buyer App", value: buyerApp };
  //   if (status) return { field: "Status", value: status };
  //   if (deliveryType) return { field: "Delivery Type", value: deliveryType };

  //   if (orderDateRange?.from && orderDateRange?.to) {
  //     return {
  //       field: "Order Date Range",
  //       value: `From: ${orderDateRange.from}, To: ${orderDateRange.to}`,
  //     };
  //   }

  //   if (deliveredDateRange?.from && deliveredDateRange?.to) {
  //     return {
  //       field: "Delivered Date Range",
  //       value: `From: ${deliveredDateRange.from}, To: ${deliveredDateRange.to}`,
  //     };
  //   }

  //   return { field: null, value: null };
  // };

  // State to manage search values

  const getSearchCriteria = (searchValues) => {
    const {
      orderId,
      ondcOrderId,
      orderType,
      buyerApp,
      status,
      deliveryType,
      from,
      to,
      orderDateRange,
      deliveredDateRange,
      deliveredFrom,
      deliveredTo,
    } = searchValues;

    const criteria = [];

    // Add individual fields to the criteria array if they exist
    if (orderId) criteria.push({ field: "Order ID", value: orderId });
    if (ondcOrderId)
      criteria.push({ field: "ONDC Order ID", value: ondcOrderId });
    if (orderType)
      criteria.push({
        field: "Order Type",
        value: orderType === "ONDC Order" ? true : false,
      });
    if (buyerApp)
      criteria.push({
        field: "Buyer App",
        value: searchOndcBapNameBySubscriberId(buyerApp),
      });
    if (status)
      criteria.push({
        field: "Status",
        value: getOrderStatusTextreverse(status),
      });
    if (deliveryType)
      criteria.push({
        field: "Delivery Type",
        value: getOrderDeliveryTypeTextReverse(deliveryType),
      });

    // Add date ranges if they exist
    if (from) {
      criteria.push({
        field: "from",
        value: from,
      });
    }

    if (to) {
      criteria.push({
        field: "to",
        value: to,
      });
    }
    if (deliveredFrom) {
      criteria.push({
        field: "deliveredFrom",
        value: deliveredFrom,
      });
    }
    if (deliveredTo) {
      criteria.push({
        field: "deliveredTo",
        value: deliveredTo,
      });
    }

    if (deliveredDateRange?.from && deliveredDateRange?.to) {
      criteria.push({
        field: "Delivered Date Range",
        value: `From: ${deliveredDateRange.from}, To: ${deliveredDateRange.to}`,
      });
    }

    // Return all the criteria or an empty array if no criteria found
    return criteria.length > 0 ? criteria : [{ field: null, value: null }];
  };

  const handleApply = async () => {
    setisError(null);

    // Check if any search criteria are provided
    const hasCriteria = Object.values(searchValues).some(
      (value) => value && value !== ""
    );

    if (!hasCriteria) {
      setisError("Select at least one search filter");
      return;
    }

    if (searchValues?.from && searchValues?.to) {
      const fromDate = moment(searchValues?.from);
      const toDate = moment(searchValues?.to);

      const isFromBeforToDate = fromDate?.isSameOrBefore(toDate);
      if (!isFromBeforToDate) {
        setisError("To date must be after or the same as the from date.");
        return;
      }
    }

    if (searchValues?.deliveredFrom && searchValues?.deliveredTo) {
      const deliveredfromDate = moment(searchValues?.deliveredFrom);
      const deliveredtoDate = moment(searchValues?.deliveredTo);


      const isDeliveredFromBeforToDate = deliveredfromDate?.isSameOrBefore(deliveredtoDate);
      if (!isDeliveredFromBeforToDate) {
        setisError("Delivered To date must be after or the same as the from date.");
        return;
      }
    }

    const businessId = sessionStorage.getItem("selectedBusinessId");
    const result = getSearchCriteria(searchValues);
    setfilterCount(result);

    let searchParams = {
      businessId: businessId,
    };

    const fieldMapping = {
      "Order ID": "orderId",
      "ONDC Order ID": "ondcOrderId",
      "Order Type": "ondcCart",
      "Buyer App": "ondcBapId",
      Status: "status",
      "Delivery Type": "deliveryType",
      from: "from",
      to: "to",
      deliveredFrom: "deliveredFrom",
      deliveredTo: "deliveredTo",
    };

    result.forEach((criteria) => {
      if (criteria.field) {
        const mappedField = fieldMapping[criteria.field];
        if (mappedField) {
          searchParams[mappedField] = criteria.value;
        }
      }
    });

    setorderData(searchParams);
    onCancel();
  };

  const FILTER_OPTIONS = [
    // { id: "01", label: "All Order", color: blackShade159 },
    { id: "01", label: "ONDC Order", color: greenStatusColor },
    { id: "02", label: "Website Order", color: orangeStatusColor },
    // { id: "04", label: "Easy Cart Order", color: redStatusColor },
    // { id: "05", label: "Influencer Order", color: perpleColor1 },
  ];

  const ORDER_FILTER_OPTIONS = [
    { id: "01", label: "Approved", color: greenStatusColor },
    { id: "02", label: "Cancel", color: perpleColor1 },
    { id: "03", label: "Created", color: blackShade159 },
    { id: "04", label: "Delivered", color: redStatusColor },
    { id: "05", label: "Shipped", color: orangeStatusColor },
    { id: "05", label: "All", color: orangeStatusColor },
  ];
  const DELIVERY_FILTER_OPTIONS = [
    { id: "01", label: "Business Delivery", color: blackShade159 },
    { id: "02", label: "Automated Delivery", color: greenStatusColor },
    { id: "03", label: "Automated Hyperlocal", color: orangeStatusColor },
    { id: "04", label: "Automated B2B", color: redStatusColor },
    { id: "05", label: "ONDC", color: perpleColor1 },
    // { id: "05", label: "Costbo Premier", color: perpleColor1 },
    // { id: "05", label: "ONDC - Standard Delivery", color: perpleColor1 },
    // { id: "06", label: "ONDC - Immediate Delivery ", color: perpleColor1 },
  ];

  // const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD

  // const handleDateChange = (newRange) => {
  //   const { from, to } = newRange;
  //   setisError("");

  //   if (from && from > today) {
  //     setisError("Start date cannot be in the future.");
  //     return;
  //   }

  //   if (from && to && to < from && to > today) {
  //     setisError("End date must be after the start date.");
  //     return;
  //   }
  //   console.log("todayto", today, to, today > to, isError);

  //   if (!isError) {
  //     setSearchValues((prev) => ({
  //       ...prev,
  //       from,
  //       to,
  //     }));
  //   }
  // };

  // const handleDeliveredDateChange = (newRange) => {
  //   const { from, to } = newRange;
  //   setisError("");
  //   // Ensure 'from' is not in the future
  //   if (from && from > today) {
  //     setisError("Start date cannot be in the future.");
  //     return;
  //   }

  //   // Ensure 'to' is after 'from'
  //   if (from && to && to < from && to > today) {
  //     setisError("End date must be after the start date.");
  //     return;
  //   }

  //   setSearchValues((prev) => ({
  //     ...prev,
  //     deliveredFrom: from,
  //     deliveredTo: to,
  //   }));
  // };

  return (
    <Box sx={styles.card} position="absolute" top="100%" right={0}>
      <Box
        sx={{
          // p: "6px 15px",
          display: "flex",
          // alignItems: "center",
          justifyContent: "space-between",
          // //   borderBottom: border25,
          background: "#f1f4f7",
          padding: "7px 15px",
          marginBottom: "10px",
          borderBottom: "1px solid #e8eaf2",
        }}
      >
        <Typography
          fontSize={{ xs: 13, md: 13.5 }}
          color={blackShade05}
          fontWeight={600}
          lineHeight="20px"
        >
          {title}
        </Typography>
        <Box display="flex" alignItems="center" gap={3}>
          <Typography
            fontSize={{ xs: 12, md: 12 }}
            color={blackShade05}
            fontWeight={600}
            lineHeight="20px"
            sx={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => {
              onAllClear();
              setisError("");
            }}
          >
            Clear All
          </Typography>
          <CloseRoundedIcon
            sx={{ fontSize: "15px", fontWeight: 700, cursor: "pointer" }}
            onClick={onCancel}
          />
        </Box>
      </Box>
      <Stack p={"0px 15px"} gap={1}>
        <Grid container columnSpacing={4} rowSpacing={1}>
          <Grid item md={6}>
            <ReportSearch
              // label={"Order ID"}
              // value={searchValues.orderId}
              // onValueChange={(value) =>
              //   setSearchValues({ ...searchValues, orderId: value })
              // }
              label="Order ID"
              placeholder="Search by Order ID"
              value={searchValues?.orderId}
              onChange={(text) => {
                // if (text === "") {
                //   // clearSearch();
                //   return;
                // }
                setSearchValues({ ...searchValues, orderId: text });
                // setSearchValues({ ...searchValues, orderId: text });
                // setSearchQuery(text);
              }}
              // onSearchClick={handleSearch}
              // errorMsg={errorMsg}
            />
          </Grid>
          <Grid item md={6}>
            <ReportSearch
              label={"ONDC Order ID"}
              placeholder="Search by ONDC Order ID"
              value={searchValues.ondcOrderId}
              onChange={(value) =>
                setSearchValues({ ...searchValues, ondcOrderId: value })
              }
            />
          </Grid>
          <Grid item md={6}>
            <SelectWithLabel
              label={"Order Type"}
              value={searchValues.orderType}
              onValueChange={(value) =>
                setSearchValues({ ...searchValues, orderType: value })
              }
              menuList={FILTER_OPTIONS || []}
              rounded
              borderFull
            />
          </Grid>
          <Grid item md={6}>
            {/* {searchValues.orderType === "ONDC Order" ? ( */}
            <SelectWithLabel
              label={"Buyer App"}
              value={searchValues.buyerApp}
              onValueChange={(value) =>
                setSearchValues({ ...searchValues, buyerApp: value })
              }
              menuList={
                bapNameList?.slice()?.sort(dynamicSort("displayName")) || []
              }
              disabled={subCategoryList?.length === 0}
              rounded
              borderFull
              valueSelector="displayName"
            />
            {/* ) : (
              ""
            )} */}
          </Grid>
          <Grid item md={6}>
            <SelectWithLabel
              label={"Status"}
              value={searchValues.status}
              onValueChange={(value) => {
                setSearchValues({ ...searchValues, status: value });
              }}
              menuList={ORDER_FILTER_OPTIONS || []}
              rounded
              borderFull
            />
          </Grid>
          <Grid item md={6}>
            <SelectWithLabel
              label={"Delivery Type"}
              value={searchValues.deliveryType}
              onValueChange={(value) =>
                setSearchValues({ ...searchValues, deliveryType: value })
              }
              menuList={DELIVERY_FILTER_OPTIONS || []}
              disabled={subCategoryList?.length === 0}
              rounded
              borderFull
            />
          </Grid>
          <Grid item md={6}>
            <DateSearchFilterWithlabel
              label={"Order Date Range"}
              data={{ from: searchValues.from, to: searchValues.to }}
              setSearchValues={(newRange) =>
                setSearchValues((prev) => ({
                  ...prev,
                  from: newRange.from,
                  to: newRange.to,
                }))
              }
              // setSearchValues={handleDateChange}
            />
          </Grid>
          <Grid item md={6}>
            <DateSearchFilterWithlabel
              label={"Delivered Date Range"}
              data={{
                from: searchValues.deliveredFrom,
                to: searchValues.deliveredTo,
              }}
              setSearchValues={(newRange) =>
                setSearchValues((prev) => ({
                  ...prev,
                  deliveredFrom: newRange.from,
                  deliveredTo: newRange.to,
                }))
              }
              // setSearchValues={handleDeliveredDateChange}
            />
          </Grid>
        </Grid>
      </Stack>
      <Box px={"15px"}>
        {isError ? (
          <Typography
            variant="subtitle1"
            component="p"
            fontSize={12}
            fontWeight={500}
            color="red"
            textAlign={"end"}
          >
            {isError}
          </Typography>
        ) : null}
      </Box>
      <Box
        display="flex"
        justifyContent={"space-between"}
        gap={2}
        sx={{ padding: { md: "6px 12px", xs: "0 12px 6px" } }}
      >
        <Button
          sx={styles.actionBtn(whiteColor, matches ? blackColor : blackShade19)}
          onClick={onCancel}
          disabled={loader}
        >
          Cancel
        </Button>

        <Button
          sx={styles.actionBtn(
            matches ? blueColor04 : mobilePrimary,
            whiteColor
          )}
          onClick={handleApply}
          disabled={loader}
        >
          Apply
        </Button>
      </Box>
    </Box>
  );
}

export default OrderReportFilterCard;

const styles = {
  card: {
    width: { md: "550px", xs: "93vw" },
    backgroundColor: whiteColor,
    borderRadius: "8px",
    border: border25,
    boxShadow: "0 1px 3px rgb(49 49 49 / 15%)",
    // my: 2,
    // overflow: "hidden",
    zIndex: 1000000,
  },
  actionBtn: (bgColor, textcolor) => ({
    padding: { md: "4px 25px", xs: "6px 12px" },
    fontSize: "11px",
    fontWeight: 600,
    color: textcolor,
    backgroundColor: bgColor,
    border: "1px solid " + textcolor,
    "&:hover": {
      color: bgColor,
      backgroundColor: textcolor,
      border: "1px solid " + bgColor,
    },
  }),
};
